<script setup lang="ts">
import { computed } from 'vue';

import type { IMessageEmits, IMessageProps, IMessageSlots } from './types';

const {
  severity = 'info',
  closable = false,
} = defineProps<IMessageProps>();

defineEmits<IMessageEmits>();
defineSlots<IMessageSlots>();

const messageIcon = computed<string | undefined>(() => {
  switch (severity) {
    case 'info':
      return 'pi pi-info-circle';
    case 'warn':
      return 'pi pi-exclamation-circle';
    case 'error':
      return 'pi pi-times-circle';
    default:
      return undefined;
  }
});
</script>

<template>
  <PMessage v-data-qa-auto-id="'VMessage'"
    :severity="severity"
    :variant="variant"
    :size="size"
    :icon="icon || messageIcon"
    :closable="closable"
    :pt="pt"
    class="word-break"
    @close="$emit('close', $event)"
  >
    <slot />
  </PMessage>
</template>
